import { Theme } from '@mui/material'

export const unavailablePageBox = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '20vh',
}

export const unavailablePageTypograpgy = {
  fontSize: '20px',
  fontWeight: 800,
}

export const unavailablePageIcon = {
  color: (theme: Theme) => theme.palette.primary.dark,
  height: '200px',
  width: '200px',
  opacity: 0.5,
}
